import {
  Component,
  Injector,
  OnInit,
  EventEmitter,
  Output,
  AfterViewInit,
} from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";
import { forEach as _forEach, map as _map } from "lodash-es";
import { AppComponentBase } from "@shared/app-component-base";
import {
  UserServiceProxy,
  CreateUserDto,
  RoleDto,
  PermissionDto,
  RoleServiceProxy,
  PermissionDtoListResultDto,
  UserDto,
  CountryServiceProxy,
  CountryDto,
  OrganizationUnitServiceProxy,
  OrganizationUnitSubjectDto,
} from "@shared/service-proxies/service-proxies";
import { AbpValidationError } from "@shared/components/validation/abp-validation.api";

declare let $ :any;

@Component({
  templateUrl: "./create-user-dialog.component.html",
})
export class CreateUserDialogComponent
  extends AppComponentBase
  implements AfterViewInit
{
  saving = false;
  user = new CreateUserDto();
  roles: RoleDto[] = [];
  checkedRolesMap: { [key: string]: boolean } = {};
  defaultRoleCheckedStatus = false;

  checkedPermissionsMap: { [key: string]: boolean } = {};
  permissions: PermissionDto[] = [];

  defaultPermissionCheckedStatus = false;

  passwordValidationErrors: Partial<AbpValidationError>[] = [
    {
      name: "pattern",
      localizationKey:
        "PasswordsMustBeAtLeast8CharactersContainLowercaseUppercaseNumber",
    },
  ];
  confirmPasswordValidationErrors: Partial<AbpValidationError>[] = [
    {
      name: "validateEqual",
      localizationKey: "PasswordsDoNotMatch",
    },
  ];

  @Output() onSave = new EventEmitter<any>();

  constructor(
    injector: Injector,
    public _userService: UserServiceProxy,
    private _roleService: RoleServiceProxy,
    private _countryService: CountryServiceProxy,
    private _organizationUnitService: OrganizationUnitServiceProxy,
    public bsModalRef: BsModalRef
  ) {
    super(injector);
    this.LoadSubjects();
    this.LoadCountries();
  }

  units: OrganizationUnitSubjectDto[] = [];
  LoadSubjects(){
    this._organizationUnitService.GetAllOrganizationsForSubject(true).subscribe(result => {
      this.units = result;
      setTimeout(() => {
        $("#SubjectId").selectpicker();
      }, 200);
    })

  }

  ngAfterViewInit(): void {
    this.user.isActive = true;

    this._userService.getRoles().subscribe((result) => {
      this.roles = result.items;
      this.setInitialRolesStatus();
    });

    this._roleService
      .getAllPermissions()
      .subscribe((result: PermissionDtoListResultDto) => {
        this.permissions = result.items;
        this.setInitialPermissionsStatus();
      });
  }

  countries: CountryDto[] = [];

  LoadCountries() {
    this._countryService.getAll('',0,9999).subscribe(res => {
      this.countries = res.items;
      setTimeout(() => {
        $("#countryIds").selectpicker();
      }, 200);
    })
  }

  setInitialPermissionsStatus(): void {
    _map(this.permissions, (item) => {
      this.checkedPermissionsMap[item.name] = this.isPermissionChecked(
        item.name
      );
    });
  }

  setInitialRolesStatus(): void {
    _map(this.roles, (item) => {
      this.checkedRolesMap[item.normalizedName] = this.isRoleChecked(
        item.normalizedName
      );
    });
  }

  isPermissionChecked(permissionName: string): boolean {
    // just return default permission checked status
    // it's better to use a setting
    return this.defaultPermissionCheckedStatus;
  }

  onPermissionChange(permission: PermissionDto, $event) {
    this.checkedPermissionsMap[permission.name] = $event.target.checked;
  }

  isRoleChecked(normalizedName: string): boolean {
    // just return default role checked status
    // it's better to use a setting
    return this.defaultRoleCheckedStatus;
  }

  onRoleChange(role: RoleDto, $event) {
    this.checkedRolesMap[role.normalizedName] = $event.target.checked;
  }

  getCheckedRoles(): string[] {
    const roles: string[] = [];
    _forEach(this.checkedRolesMap, function (value, key) {
      if (value) {
        roles.push(key);
      }
    });
    return roles;
  }

  save(): void {
    this.saving = true;

    this.user.roleNames = this.getCheckedRoles();

    this._userService.create(this.user).subscribe(
      (User:UserDto) => {
        this.notify.info(this.l("SavedSuccessfully"));
        this.bsModalRef.hide();
        this.onSave.emit(User);
      },
      () => {
        this.saving = false;
      }
    );
  }
}
